import {UsersService} from "@hassel-it/angular-common";
import {User} from "@hassel-it/angular-common";
import {ActivatedRoute, Router} from "@angular/router";
import {Component, OnInit} from '@angular/core';
declare let NProgress: any;

@Component({
    providers:[UsersService],
  selector: 'app-user-manager',
  templateUrl: './user-manager.component.html',
  styleUrls: ['./user-manager.component.scss']
})
export class UserManagerComponent implements OnInit {

    initialized = true;
    users: User[];
    filter: any;

    public page: number = 1;
    public perPage: number = 20;
    public total: number;
    paginationData = { searchQuery:null };

    constructor(public usersService: UsersService,
                public route: ActivatedRoute,
                public router: Router,
                private activatedRoute: ActivatedRoute) {
        this.filter = {};
    }

    ngOnInit() {

        this.activatedRoute.queryParams.subscribe(result => {
            if (result.page) {
                this.page = result.page;
            }
            this.paginationData.searchQuery = result?.searchQuery;
            this.filter.searchQuery = result?.searchQuery;
            this.getPage(this.page);
        });


    }

    ngOnDestroy() {
        this.initialized = false;

        NProgress.done();
    }

    getPage(page: number) {
        NProgress.start();
        this.filter.page = page;
        this.filter.all = true;
        this.usersService.getUsers(this.filter).then(result => {
            if (this.initialized) {
                this.users = result.results;
                this.total = result.count;
                this.filter.page = page;
                this.page= page;
                NProgress.done();
            }
        });
    }

    onSearch() {
        console.log(this.paginationData.searchQuery);
        this.router.navigate(
            [],
            {
                relativeTo: this.route,
                queryParams: {page: 1, searchQuery: this.paginationData.searchQuery},
            });
    }


    deleteUser(user: User) {
        if (confirm("Are you sure ?")) {
            this.usersService.deleteUser(user).then((result) => {
                this.filter.searchQuery = null;
                this.router.navigate(
                    [],
                    {
                        relativeTo: this.route,
                        queryParams: {page: 1, searchQuery: this.filter.searchQuery},
                    });
            }, (error) => {
                alert('kunne ikke slette bruger');
            });
        }
    }

}
